import { createAction } from "redux-actions";
import { urls } from "../constants/app";
import request from "./utils/request";
import { makeActionType } from "../utils";
import { resetError, setError } from "./errors";
import { setActiveModalAction } from "./goods";

const namespace = 'RAW';

export const setRaws = createAction(makeActionType(namespace, ['SET']));
export const setRaw = createAction(makeActionType(namespace, ['SET', 'RAW']));
export const addRawList = createAction(makeActionType(namespace, ['ADD', 'RAW']));
export const deleteRawAction = createAction(makeActionType(namespace, ['DELETE', 'RAW']));
export const setCategoriesRaw = createAction(makeActionType(namespace, ['SET', 'CATEGORIES']));
export const setPagingRaws = createAction(makeActionType(namespace, ['SET', 'PAGING']));
export const setSortingRaws = createAction(makeActionType(namespace, ['SET', 'SORTING']));
export const setCountRaws = createAction(makeActionType(namespace, ['SET', 'COUNT']));
export const setDetailRaw = createAction(makeActionType(namespace, ['SET', 'DETAIL']));
export const setActiveCategoryRaw = createAction(makeActionType(namespace, ['SET', 'ACTIVE_CATEGORY']));

export function fetchRawsList(withoutLoader = false, returnIt = false, params) {
    return async (dispatch) => {
        !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'raws', value: true });
        dispatch(resetError('raws'));
        try {
            const raws = await request({ method: 'get', url: `${urls.rawmaterials}/list`, params });
            dispatch(setRaws(raws))
            dispatch(setCountRaws(raws.length));
            !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'raws', value: false });
            if (returnIt) return raws;
        } catch(error) {
            dispatch(setError(error, 'raws'));
            !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'raws', value: false });
            if (returnIt) return null;
        }
    }
}

export function fetchRaws(params, countParams) {
    return async (dispatch) => {
        dispatch(resetError('raws'));
        try {
            const data = await request({ method: 'get', url: urls.rawmaterials, params });
            const count = await request({ method: 'get', url: `${urls.rawmaterials}/count`, params: countParams });
            return { data, count };
        } catch(error) {
            dispatch(setError(error, 'raws'));
        }
    }
}

export function fetchRaw(id, returnIt = false) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'detailRaw', value: true });
        dispatch(resetError('detailRaw'));
        try {
            const list = getState().raw.list;
            const itemRaw = list.find((item) => item.id === +id);

            if (itemRaw) {
                if (returnIt) {
                    return itemRaw;
                } else {
                    dispatch(setDetailRaw(itemRaw));
                }
                dispatch({ type: 'SET_LOADER', field: 'detailRaw', value: false });
            } else {
                const raw = await request({ method: 'get', url: `${urls.rawmaterials}/${id}` });
                if (returnIt) {
                    return raw;
                } else {
                    dispatch(setDetailRaw(raw));
                }
                dispatch({ type: 'SET_LOADER', field: 'detailRaw', value: false });
            }
        } catch(error) {
            dispatch(setError(error, 'detailRaw'));
            dispatch({ type: 'SET_LOADER', field: 'detailRaw', value: false });
        }
    }
}

export function addRaw(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'modalRaw', value: true });
        try {
            const raw = await request({ method: 'post', url: urls.rawmaterials, data });
            if (raw) {
                dispatch({ type: 'SET_LOADER', field: 'modalRaw', value: false });
                dispatch(addRawList(raw));
                return raw.id;
            }
        } catch(error) {
            dispatch(setError({ status: 506 }, 'modalRaw'));
            dispatch({ type: 'SET_LOADER', field: 'modalRaw', value: false });
            return null;
        }
    }
}

export function importRaw(list) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'raws', value: true });
        try {
            const result = await Promise.all(list.map(async (data) => {
                if (data.updated) {
                    const raw = await request({ method: 'put', url: `${urls.rawmaterials}/${data.updated}`, data });
                    dispatch(setRaw(raw));
                    return data.updated;
                } else {
                    const raw = await request({ method: 'post', url: urls.rawmaterials, data });
                    if (raw) {
                        dispatch(addRawList(raw));
                        return raw.id;
                    }
                }                
            }));

            dispatch({ type: 'SET_LOADER', field: 'raws', value: false });
            return result;
        } catch(error) {
            dispatch(setError({ status: 506 }, 'raws'));
            dispatch({ type: 'SET_LOADER', field: 'raws', value: false });
            return null;
        }
    }
}

export function updateRaw(id, data) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'updateRaw', value: id });
        dispatch(resetError('raws'));

        try {
            const detail = getState().raw.detail;
            const raw = await request({ method: 'put', url: `${urls.rawmaterials}/${id}`, data });
            dispatch(setRaw(raw));
            if (detail) {
                dispatch(setDetailRaw(raw));
            }
            dispatch({ type: 'SET_LOADER', field: 'updateRaw', value: null });
            return raw.id;
        } catch(error) {
            dispatch(setError(error, 'raws'));
            dispatch({ type: 'SET_LOADER', field: 'updateRaw', value: null });
            return null;
        }
    }
}

export function deleteRaw(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'deleteRaw', value: id });
        dispatch(resetError('raws'));
        try {
            await request({ method: 'delete', url: `${urls.rawmaterials}/${id}` });
            dispatch(deleteRawAction(id));
            dispatch({ type: 'SET_LOADER', field: 'deleteRaw', value: null });
        } catch(error) {
            dispatch(setError({ status: 507 }, 'raws'));
            dispatch({ type: 'SET_LOADER', field: 'deleteRaw', value: null });
        }
    }
}

export function fetchProductCategories(type) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'productCategory', value: true });
        dispatch(resetError('productCategory'));
        try {
            const activeCategory = getState().raw.activeCategory;
            const items = await request({ method: 'get', url: urls.productscategories });
            dispatch(setCategoriesRaw(items));
            if (!activeCategory && type) {
                const activeCat = items.find((item) => item.type === type);
                dispatch(setActiveCategoryRaw(activeCat ? activeCat.id : null));
            }
            dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
        } catch(error) {
            dispatch(setError(error, 'productCategory'));
            dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
        }
    }
}

export function addProductCategory(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'productCategory', value: true });

        try {
            const result = await request({ method: 'post', url: urls.productscategories, data });
            if (result) {
                dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
                dispatch(fetchProductCategories(data.type));
                return true;
            }
        } catch(error) {
            dispatch(setError({ status: 506 }, 'productCategory'));
            dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
            return false;
        }
    }
}

export function updateProductCategory(id, data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'productCategory', value: true });

        try {
            const result = await request({ method: 'put', url: `${urls.productscategories}/${id}`, data });
            if (result) {
                dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
                dispatch(fetchProductCategories(data.type));
                dispatch(fetchRawsList());
                return true;
            }
        } catch(error) {
            dispatch(setError({ status: 506 }, 'productCategory'));
            dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
            return false;
        }
    }
}

export function deleteProductCategory(id, type) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'productCategory', value: true });
        try {
            await request({ method: 'delete', url: `${urls.productscategories}/${id}` });
            dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
            dispatch(fetchProductCategories(type));
            dispatch(setActiveModalAction({ field: 'productCategory', value: null }))
        } catch(error) {
            dispatch(setError({ status: 507 }, 'productCategory'));
            dispatch({ type: 'SET_LOADER', field: 'productCategory', value: false });
        }
    }
}

export const getRecipeSemiById = (id) => async (dispatch, getState) => {
    const detail = getState().raw.detail;
    dispatch({ type: 'SET_LOADER', field: 'recipeSemi', value: true });
    dispatch(resetError('recipeSemi'));
    try {
        const params = {
            type: 'semi',
            productId: id,
            "_sort": 'startDate:DESC'
        }
        const recipes = await request({ method: 'get', url: urls.recipes, params });
        dispatch(setDetailRaw({ ...detail, recipes: recipes }));
        dispatch({ type: 'SET_LOADER', field: 'recipeSemi', value: false });
    } catch (error) {
        dispatch(setError(error, 'goods'));
        dispatch({ type: 'SET_LOADER', field: 'recipeSemi', value: false });
    }
};